// extracted by mini-css-extract-plugin
module.exports = {"LandingFooter":"index__LandingFooter___2ErSb","entry":"index__entry___3Am9F typography__bodyFont___1exgA","entryLink":"index__entryLink___1b7WJ"};